/* ============================================================
   JULHIMMEL — paketval och "lägg i varukorgen" (galleri, sticky och meny sköts av sk.js)
   ============================================================ */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function money(cents) {
    var c = Math.round(cents);
    return new Intl.NumberFormat('sv-SE', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(c / 100) + ' kr';
  }
  function init() {
    var pdp = document.querySelector('[data-jh-pdp]');
    if (!pdp || pdp.dataset.jhReady) return;
    pdp.dataset.jhReady = '1';
    var form = pdp.querySelector('[data-jh-form]');
    var idInput = form.querySelector('[data-jh-id]');
    var qtyInput = form.querySelector('[data-jh-qty]');
    var atc = form.querySelector('[data-jh-atc]');
    var err = form.querySelector('[data-jh-error]');
    var pkgs = Array.prototype.slice.call(pdp.querySelectorAll('[data-jh-pkg]'));
    var sName = document.querySelector('[data-jh-sticky-name]');
    var sPrice = document.querySelector('[data-jh-sticky-price]');
    var sBuy = document.querySelector('[data-sk-sticky-buy]');
    var params = new URLSearchParams(location.search);
    var cur = pkgs.find(function (b) { return b.dataset.qty === params.get('paket'); }) || pkgs.find(function (b) { return b.getAttribute('aria-checked') === 'true'; }) || pkgs[0];

    function render() {
      pkgs.forEach(function (b) { var on = b === cur; b.setAttribute('aria-checked', String(on)); b.tabIndex = on ? 0 : -1; });
      var ok = cur && cur.dataset.available === 'true';
      qtyInput.value = cur.dataset.qty;
      atc.disabled = !ok;
      atc.textContent = ok ? atc.dataset.label : 'Slut i lager';
      if (sName) sName.textContent = cur.dataset.name;
      if (sPrice) sPrice.textContent = money(Number(cur.dataset.price));
      if (sBuy) sBuy.disabled = !ok;
      err.textContent = '';
      var url = new URL(location.href); url.searchParams.delete('variant'); url.searchParams.set('paket', cur.dataset.qty);
      history.replaceState(history.state, '', url);
    }
    pkgs.forEach(function (b, i) {
      b.addEventListener('click', function () { cur = b; render(); });
      b.addEventListener('keydown', function (e) {
        var n = pkgs.length, k = e.key, j = pkgs.indexOf(cur);
        if (k === 'ArrowRight' || k === 'ArrowDown') j = (j + 1) % n;
        else if (k === 'ArrowLeft' || k === 'ArrowUp') j = (j - 1 + n) % n;
        else return;
        e.preventDefault(); cur = pkgs[j]; render(); cur.focus();
      });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc.disabled || atc.getAttribute('aria-busy') === 'true') return;
      atc.setAttribute('aria-busy', 'true');
      var sections = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: Number(cur.dataset.qty) }], sections: sections.join(','), sections_url: ROOT + 'variants/' + idInput.value })
      }).then(function (res) { return res.json().then(function (j) { return { ok: res.ok, json: j }; }); })
        .then(function (r) {
          if (!r.ok) { err.textContent = r.json.description || r.json.message || 'Något gick fel. Försök igen.'; return; }
          return fetch(ROOT + 'cart.js').then(function (res) { return res.json(); }).then(function (cart) {
            cart.sections = r.json.sections;
            form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: r.json.items || [], cart: cart } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
          });
        })
        .catch(function () { err.textContent = 'Något gick fel. Försök igen.'; })
        .then(function () { atc.removeAttribute('aria-busy'); });
    });
    render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
